// src/app/page.tsx
import { FC, useState } from "react";
import { Slider, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import OpenAI from "../../../../assets/images/openai.svg";
import "./index.css";
import Dropdown from "../../../../components/Dropdown";

const Chat: FC = () => {
  const theme = useTheme();

  const llmSelectorOptions = [
    { id: 1, name: "OpenAI" },
    { id: 2, name: "Claude" },
  ];

  const [selectedOption, setSelectedOption] = useState("1");

  return (
    <div className="chat-section">
      <Typography>Chat</Typography>
      <Grid container className="chat-container">
        <Grid size={{ xs: 12, md: 12 }}>
          <Typography>LLM Selector</Typography>
          {/* <div className="openai">
            <img src={OpenAI} />
          </div> */}
          <Dropdown
            label={""}
            items={llmSelectorOptions}
            value={selectedOption}
            handleChange={(e) => setSelectedOption(e.target.value)}
          />
          <div className="tolerance-section">
            <Typography>Hallucination Tolerance</Typography>
            <Slider
              aria-label="Temperature"
              defaultValue={30}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={10}
              marks
              min={10}
              max={110}
              sx={{
                backgroundColor: "#2a945f",
                color: theme.palette.background.default,
                marginTop: "4px",
              }}
            />
          </div>
          <div className="automation-section">
            <Typography>Automation Tolerance</Typography>
            <Slider
              disabled
              aria-label="Temperature"
              defaultValue={30}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={10}
              marks
              min={10}
              max={110}
              sx={{
                backgroundColor: "#2a945f",
                color: theme.palette.background.default,
                marginTop: "4px",
              }}
            />
          </div>
          <div className="personality-section">
            <Typography>Personality</Typography>
            <textarea
              className="personality-textarea"
              placeholder="Section for personality"
              style={{ backgroundColor: theme.palette.background.default }}
            ></textarea>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Chat;
